import ArrowRightRoundedIcon from "@mui/icons-material/ArrowRightRounded";

export default function ArrowRightMediumRoundedIcon() {
  return <ArrowRightRoundedIcon fontSize="medium" />;
}
